import type { Activity, GraduateYear, NewsPost, PublicHome } from '@htl/api';

type Temporary<T> = T & { temporary: true };

// TEMPORARY: preserved from the October 2026 landing page until the Laravel public API is approved.
export const temporaryNews: Temporary<NewsPost>[] = [
  {
    temporary: true,
    id: 'temporary-news-1',
    slug: 'a-new-school-year-begins',
    title: 'A new school year begins',
    excerpt: 'Welcoming students, families, and teachers back to a year of learning and possibility.',
    body: '<p>Hsa Thoo Lei welcomes students, families, and teachers back for a new school year filled with learning, belonging, and possibility.</p>',
    publishedAt: '2026-05-20',
    coverImage: { url: '/images/school-community.jpg', alt: 'Students and teachers gathered at Hsa Thoo Lei Learning Center' },
  },
  {
    temporary: true,
    id: 'temporary-news-2',
    slug: 'celebrating-our-ged-graduates',
    title: 'Celebrating our GED graduates',
    excerpt: 'A proud moment for students who have worked with commitment and courage.',
    body: '<p>We celebrate the graduates whose commitment, courage, and steady work brought them to this important milestone.</p>',
    publishedAt: '2026-04-12',
    coverImage: { url: '/images/activities/activity-02.jpg', alt: 'Students celebrating together at school' },
  },
  {
    temporary: true,
    id: 'temporary-news-3',
    slug: 'community-learning-day',
    title: 'Community learning day',
    excerpt: 'Families and teachers came together to share learning, food, and stories.',
    body: '<p>Families, teachers, and students came together to share learning, food, stories, and time as one school community.</p>',
    publishedAt: '2026-03-29',
    coverImage: { url: '/images/activities/activity-03.jpg', alt: 'The Hsa Thoo Lei school community learning together' },
  },
];

// TEMPORARY: captions and the first three live landing-page images are intentionally preserved.
export const temporaryActivities: Temporary<Activity>[] = [
  {
    temporary: true,
    id: 'temporary-activity-1',
    title: 'Celebrating together',
    description: 'School celebrations bring students, teachers, families, and neighbours together through culture, music, and shared moments.',
    body: [
      'Celebrations at Hsa Thoo Lei are a chance for the whole school community to gather, recognise student effort, and share the traditions that connect us.',
      'Students take an active part through music, dance, welcoming guests, and helping one another throughout the day. These experiences build confidence while creating memories beyond the classroom.',
      'This story is temporary content preserved from the earlier website. A complete event report and additional photographs can be added through the school content system later.',
    ],
    year: 2026,
    images: [{ url: '/images/activities/activity-01.jpg', alt: 'Students celebrating together at Hsa Thoo Lei' }],
  },
  {
    temporary: true,
    id: 'temporary-activity-2',
    title: 'Learning beyond the classroom',
    description: 'Practical activities, teamwork, and study visits help students connect lessons with everyday life.',
    body: [
      'Learning continues beyond desks and textbooks. Practical activities give students room to ask questions, work with others, and use what they have learned in a real setting.',
      'These shared experiences support communication, responsibility, and curiosity. Teachers guide each activity so students can take part safely and reflect on what they discover.',
      'This story is temporary content preserved from the earlier website. The school can replace it with the full activity report when the public content API is connected.',
    ],
    year: 2026,
    images: [{ url: '/images/activities/activity-02.jpg', alt: 'Students learning beyond the classroom at Hsa Thoo Lei' }],
  },
  {
    temporary: true,
    id: 'temporary-activity-3',
    title: 'Our school community',
    description: 'Community days create space for students, families, teachers, and partners to learn from one another.',
    body: [
      'Hsa Thoo Lei grows through the care and participation of students, families, teachers, staff, and community partners.',
      'Community activities help people meet, exchange ideas, celebrate progress, and strengthen the relationships that support every learner throughout the school year.',
      'This story is temporary content preserved from the earlier website. More specific names, dates, and photographs can be published after the school approves them.',
    ],
    year: 2026,
    images: [{ url: '/images/activities/activity-03.jpg', alt: 'Members of the Hsa Thoo Lei school community' }],
  },
];

// TEMPORARY: the live site currently shows 140 graduates without approved public names.
export const temporaryGraduateYears: Temporary<GraduateYear>[] = [
  { temporary: true, id: 'cohort-2026', year: 2026, schoolYear: '2025–2026', recordedCount: 35, graduates: [] },
  { temporary: true, id: 'cohort-2025', year: 2025, schoolYear: '2024–2025', recordedCount: 35, graduates: [] },
  { temporary: true, id: 'cohort-2024', year: 2024, schoolYear: '2023–2024', recordedCount: 35, graduates: [] },
  { temporary: true, id: 'cohort-2023', year: 2023, schoolYear: '2022–2023', recordedCount: 35, graduates: [] },
];

export const temporaryHome: PublicHome = {
  graduateTotal: 140,
  latestNews: temporaryNews,
  activities: temporaryActivities,
};

export const temporaryFallbacks = {
  home: temporaryHome,
  activities: temporaryActivities,
  graduates: temporaryGraduateYears,
  news: temporaryNews,
};

